const styles = theme => {
  return {
    root: {
      width: '100%',
      marginBottom: '2px',
      display: 'flex',
      flexDirection: 'column'
    },
    tableRoot: {
      marginLeft: '40px',
      backgroundColor: '#FAFAFA'
    },
    headerCell: {
      backgroundColor: '#E0E0E0',
      fontSize: '12px',
      fontWeight: 600
    },
    switchRoot: { display: 'flex', alignItems: 'center' },
    expandSwitchLabel: { fontSize: '12px', color: '#000' },
    headerRoot: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#fff',
      padding: '10px 20px',
      marginTop: '5px'
    },
    actionContainer: { display: 'flex', alignItems: 'center' },
    icon: {
      fontSize: '30px',
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      },
      [theme.breakpoints.down('xs')]: {
        display: 'flex'
      }
    },
    title: {
      fontSize: '18px',
      fontWeight: 500,
      padding: '0 20px',
      [theme.breakpoints.down('xs')]: {
        display: 'none'
      }
    },
    label: {
      display: 'flex',
      fontSize: '12px',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        justifyContent: 'center'
      }
    },
    loaderOverlay: {
      position: 'absolute',
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      background: '#FFF',
      opacity: '.5',
      zIndex: 100,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  };
};

export default styles;
